import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín L.',
    city: 'Pergamino',
    text: 'Doy clases hace años en escuela técnica y siempre perdía horas armando casos prácticos. Este kit me salvó. Los alumnos entienden mucho mejor la gestión real.',
    role: 'Profesor de gestión agropecuaria'
  }, {
    name: 'Carolina S.',
    city: 'Rosario',
    text: 'Enseñar leyes a veces es denso, pero el tomo de legislación lo hace súper práctico. Mis alumnos universitarios agradecen los ejemplos claros.',
    role: 'Docente de legislación rural'
  }, {
    name: 'Jorge R.',
    city: 'Córdoba',
    text: 'El material de seguridad e higiene está impecable. Lo uso para capacitar operarios y la estructura es perfecta. Muy recomendable.',
    role: 'Instructor de seguridad rural'
  }, {
    name: 'Lucía M.',
    city: 'Mendoza',
    text: 'La planificación anual es oro puro. Entro al aula sabiendo exactamente qué toca hoy y cómo evaluarlo. Me ahorró muchísimo tiempo.',
    role: 'Profesora de administración agropecuaria'
  }, {
    name: 'Fernando P.',
    city: 'Entre Ríos',
    text: 'Compramos el sistema Pro para los docentes de la escuela. La calidad técnica de los contenidos y las actividades imprimibles son excelentes.',
    role: 'Director de escuela agrotécnica'
  }];
  return <section className="bg-[#E8F5E9] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-180">
      <div className="max-w-4xl mx-auto" data-id="element-181">
        <h2 className="text-xl md:text-2xl font-black text-[#1F3D2B] text-center mb-3 uppercase tracking-tight" data-id="element-182">
          Testimonios de docentes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1.5" data-id="element-183">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-gray-200 p-2.5 rounded-lg flex flex-col shadow-sm" data-id="element-184">
              <div className="text-[#D4A843] text-xs mb-1 tracking-widest" data-id="element-185">
                ★★★★★
              </div>
              <p className="text-gray-700 font-bold text-xs mb-2 flex-grow italic" data-id="element-186">
                "{t.text}"
              </p>
              <div className="border-t border-gray-100 pt-1.5" data-id="element-187">
                <p className="font-black text-[#1F3D2B] text-xs uppercase" data-id="element-188">
                  {t.name}
                </p>
                <p className="text-[10px] font-bold text-gray-500 uppercase" data-id="element-189">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}